var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "manager_dashboard" },
    [
      _c("user-menu"),
      _vm._v(" "),
      _c("div", { staticClass: "wrapper" }, [
        _c("div", { staticClass: "content-wrapper" }, [
          _c("div", { staticClass: "container-wrapper center" }, [
            _vm._m(0),
            _vm._v(" "),
            _c("div", { staticClass: "heading-seperator" }),
            _vm._v(" "),
            _c("div", { staticClass: "margin-bottom-10" }),
            _vm._v(" "),
            _c("div", { staticClass: "row justify-content-lg-center" }, [
              _c(
                "div",
                { staticClass: "col-6 mt-4" },
                _vm._l(_vm.locations, function(item, index) {
                  return _c("div", { key: index, staticClass: "row ea-row" }, [
                    _c(
                      "div",
                      { staticClass: "col-12 col-sm-12 col-md-12 col-lg-12" },
                      [
                        _c("div", { staticClass: "ea-card-box" }, [
                          _vm._m(1, true),
                          _vm._v(" "),
                          _c("div", { staticClass: "loc_item_2" }, [
                            _c("div", { staticClass: "account-name" }, [
                              _vm._v(_vm._s(item.accountName))
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "account-address" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.formatAddress(item.city, item.stateName)
                                )
                              )
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "account-address" }, [
                              _c("span", { staticClass: "font-weight-bold" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.formatGroupTitle(item.groupsAssigned)
                                  )
                                )
                              ]),
                              _vm._v(
                                "\n                                            " +
                                  _vm._s(_vm.formatGroup(item.groupsAssigned)) +
                                  "\n                                        "
                              )
                            ])
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "loc_item_3 mt-4",
                              on: {
                                click: function($event) {
                                  return _vm.setCurrentLocation(item)
                                }
                              }
                            },
                            [
                              _c("img", {
                                attrs: {
                                  src: require("@/assets/enterprise/right-chevron-blue.png"),
                                  width: "32"
                                }
                              })
                            ]
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "clearfix" })
                        ])
                      ]
                    )
                  ])
                }),
                0
              )
            ])
          ])
        ])
      ])
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c("h3", { staticClass: "text-center heading" }, [
        _vm._v("Select a Location")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "loc_item_1" }, [
      _c("img", {
        attrs: {
          src: require("@/assets/enterprise/branded_location_icon.png"),
          width: "32"
        }
      })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0c662d98", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0c662d98","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/user_select_location.vue
// module id = null
// module chunks = 